
import {
  LowResolutionDesktops,
  MainContainer,
  MainContainerMobile,
} from "./recomendationsSection/MainComponent";

export const RecomendationsSideBar = ({ isMobile, uiTexts, isLowResolution }) => {
  return (
    <>
      <div
        style={{ padding: isMobile && 0, margin: isMobile && 0 }}
      >

      </div>
      {isMobile ? <MainContainerMobile /> : <MainContainer />}
    </>
  );
  
};
